import { PAGE_CONTEXT_SET_CURRENT, PAGE_CONTEXT_SET_SUPPORT_ORIGIN } from "./actions";

const initialState = {
  currentPageId: null, // numeric id from 1..20
  currentPageName: "",
  route: "",
  meta: {}, // any extra info (e.g., add/edit + step)
  lastSupportClick: null, // { pageId, pageName, route, meta, note, triggeredAt }
};

export const pageContextReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_CONTEXT_SET_CURRENT: {
      const { id, route, meta } = action.payload || {};
      return {
        ...state,
        currentPageId: id?.id || id || null,
        currentPageName: id?.name || meta?.name || "",
        route: route || state.route,
        meta: meta || {},
      };
    }
    case PAGE_CONTEXT_SET_SUPPORT_ORIGIN: {
      return {
        ...state,
        lastSupportClick: action.payload,
      };
    }
    default:
      return state;
  }
};


